import {Component, Input, OnInit} from '@angular/core';
import {ZapisnyList} from '../model/zapisnyList';
import {AppService} from '../app.service';
import { MatDialog } from '@angular/material/dialog';
import {ConfirmDialogComponent} from 'ais-common';
import { HttpErrorResponse } from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {HarmonogramRokaComponent} from '../harmonogram-roka/harmonogram-roka.component';

@Component({
    selector: 'app-zapisny-list',
    templateUrl: './zapisny-list.component.html',
    styleUrls: ['./zapisny-list.component.css'],
    standalone: false
})
export class ZapisnyListComponent implements OnInit {

  @Input()
  zapisnyList: ZapisnyList;

  show = true;

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private translation: TranslateService
  ) { }

  ngOnInit() {
  }

  zapisPredmetovKredity() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES213_ZapisPredmetovKredityDlg', this.zapisnyList.id);
  }

  priebezneHodnotenie() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES016_StudentPrehladPriebeznehoHodnoteniaDlg', this.zapisnyList.id);
  }

  terminyHodnotenia() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES007_StudentZoznamPrihlaseniNaSkuskuDlg', this.zapisnyList.id);
  }

  hodnoteniaPriemery() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES212_HodnoteniaPriemeryDlg', this.zapisnyList.id);
  }

  prihlasenieNaTerminHodnotenia() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.light.VSES333_PrihlasovanieStudentaNaHodnotenieDlg', this.zapisnyList.id);
  }

  prihlasenieNaRozvrh() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES215_ZaradovanieNaRozvrhDlg', this.zapisnyList.id);
  }

  tlacDokumentov() {
    this.appService.openPortalAppWindow('ais.gui.vs.es.VSES290_DokumentyTlacDlg', 'z' + this.zapisnyList.id);
  }

    odobratZapisnyList()
    {
        const dialogRef = this.dialog.open(
            ConfirmDialogComponent, {
              panelClass: 'alert-warning',
              data: {message: this.translation.instant('Želáte si odstrániť zápisný list?')},
              width: '500px',
            }
        );

        dialogRef.afterClosed().subscribe((result: string) => {
          if ('OK' === result) {
            this.appService.zrusZapisnyList(this.zapisnyList.id)
              .subscribe({
                next: () => {
                    this.appService.fetchStudia(true);
                    this.appService.openOkDialog(this.translation.instant('zapisny_list_bol_odstraneny'));
                    this.show = false;
                  },
                error: (error) => {
                  if (error instanceof HttpErrorResponse) {
                    this.appService.openErrorDialog(error.error.message);
                  }
                }
              });
          }
        });
    }

    goToStudentPredmetyApp(zapisnyList: ZapisnyList)
    {
        const url =
          '/ais/apps/student-predmety/'
          + this.translation.currentLang.toLowerCase()
          + '?zl=' + zapisnyList.id;

        window.location.href = url;
    }

    harmonogramAkRoka() {
      this.appService.openDialog(HarmonogramRokaComponent, this.zapisnyList);
    }

    getZapisnyListTitle(zapisnyList: ZapisnyList) {
      return zapisnyList.akademickyRok + ' ('  + zapisnyList.rocnik + zapisnyList.studijnyProgram.skratka + zapisnyList.kodKruzok + ')';
    }

    openElektronickyZapis() {
        window.location.href = '/ais/apps/zapis/' + this.translation.currentLang.toLowerCase() +
            '?studium=' + this.zapisnyList.idStudium + '&zl=' + this.zapisnyList.id;
    }
}
